import { VList } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,_vm._l((_vm.links),function(link,index){return _c('NavigationLink',{key:index,attrs:{"link":link}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }